import type { FacetedFiltersResponse } from '@shared/api/findings/findings-api.types';
import type { FacetedFilter, ModalPosition } from '@shared/api/findings/findings.types';

export function getModalPosition(
  triggerTop: number | undefined,
  triggerLeft: number | undefined,
  triggerWidth: number | undefined,
): ModalPosition {
  const computedLeft =
    typeof triggerLeft === 'number' && typeof triggerWidth === 'number' ? triggerLeft + triggerWidth : 260;
  const computedTop = typeof triggerTop === 'number' ? triggerTop : 160;

  return { left: computedLeft, top: computedTop };
}

export function mapFacetedFiltersToUI(filtersDataApi: FacetedFiltersResponse | undefined): FacetedFilter[] {
  return (
    filtersDataApi?.filters?.map((f) => ({
      key: f.filterKey,
      label: f.filterKey,
      options: f.values.map((v) => ({ value: v.filterValue, label: v.filterValue, count: v.valueCount })),
      operator: 'IS' as const,
      selected: [],
    })) ?? []
  );
}
